import React from 'react';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import Camera from '../../Camera/Camera';

import windscreen from '../../../assets/images/windshield.png';
import frontView from '../../../assets/images/frontcar.png';
import licenceDisc from '../../../assets/images/licencedisc.png';

// compression to enforce 5MB limit
const compressImage = (base64Str) => new Promise((resolve) => {
  const img = new Image();
  img.src = base64Str;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    let { width, height } = img;

    const MAX_DIMENSION = 2500;
    if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
      const ratio = Math.min(MAX_DIMENSION / width, MAX_DIMENSION / height);
      width *= ratio;
      height *= ratio;
    }

    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);

    let quality = 0.95;
    let result = canvas.toDataURL('image/jpeg', quality);

    while (result.length > 5242880 && quality > 0.5) {
      quality -= 0.1;
      result = canvas.toDataURL('image/jpeg', quality);
    }

    resolve(result);
  };
});

class TakePhotoModal extends React.Component {
  constructor(props) {
    super(props);

    this.onPhotoCaptured = this.onPhotoCaptured.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.clearPhoto = this.clearPhoto.bind(this);
    this.state = {
      Image: null,
      isSaving: false,
    };
  }

  async handleSaveClick() {
    if (!this.state.Image) {
      toastr.warning('Please capture an image first.', 'Missing Image');
      return;
    }
    this.setState({ isSaving: true });

    try {
      // Compress the image (enforce 5MB limit)
      const finalImage = await compressImage(this.state.Image);
      this.props.Action(finalImage, this.props.ImageName);
      this.props.Hide();
    } catch (error) {
      console.error('Compression failed', error);
      this.setState({ isSaving: false });
      toastr.error('Failed to process the image.', 'Oops');
    }
  }

  onPhotoCaptured(photoBase64) {
    this.setState({ Image: photoBase64 });
  }

  clearPhoto() {
    this.setState({ Image: null });
  }

  render() {
    const isLicenceDisc = this.props.ImageName === 'LicenceDisc' ? licenceDisc : frontView;
    const overlayImg = this.props.ImageName === 'Damage' ? windscreen : isLicenceDisc;
    return (
      <div id={`takePhotoModal${this.props.ImageName}`} className="modal fade in" style={{ display: 'block' }}>
        <div className="modal-dialog modal-confirm">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-hidden="true"
                onClick={() => this.props.Hide()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <Camera
                  container={`takePhotoModal${this.props.ImageName}`}
                  onPhotoCaptured={this.onPhotoCaptured}
                  overlay={overlayImg}
                  capturedImage={this.state.Image}
                  onClear={this.clearPhoto}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-info"
                onClick={() => this.props.Hide()}
                disabled={this.state.isSaving}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-succ"
                onClick={this.handleSaveClick}
                disabled={this.state.isSaving}
              >
                {this.state.isSaving ? 'Processing...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TakePhotoModal.propTypes = {
  ImageName: PropTypes.string.isRequired,
  Action: PropTypes.func.isRequired,
  Hide: PropTypes.func.isRequired,
};

export default TakePhotoModal;
